export default {
  step5: [
    {
      id:22,
      step: 5,
      tab:1,
      stepJp:"リング幅",
      name: "1.8mm",
      property: "width",
      val: "1.8mm",
      order_id: 1,
      summary:"",
      // price:0,
    },
    {
      id:22123,
      step: 5,
      tab:1,
      stepJp:"リング幅",
      name: "2.0mm",
      property: "width",
      val: "2.0mm",
      order_id: 1,
      summary:"",
      // price:0,
    },
    {
      id:23,
      step: 5,
      tab:1,
      stepJp:"リング幅",
      name: "2.2mm",
      property: "width",
      val: "2.2mm",
      order_id: 2,
      summary:"",
      // price:10000,
    },
    {
      id:24,
      step: 5,
      tab:2,
      stepJp:"リング幅",
      name: "2.4mm",
      property: "width",
      val: "2.4mm",
      order_id: 3,
      summary: "",
      // price:10000,
    },
    {
      id:25,
      step: 5,
      tab:2,
      stepJp:"リング幅",
      name: "2.6mm",
      property: "width",
      val: "2.6mm",
      order_id: 4,
      summary:"",
      // price:20000,
    },
    {
      id:26,
      step: 5,
      tab:2,
      stepJp:"リング幅",
      name: "2.8mm",
      property: "width",
      val: "2.8mm",
      order_id: 5,
      summary:"",
      // price:20000,
    },
    {
      id:27,
      step: 5,
      tab:2,
      stepJp:"リング幅",
      name: "3.0mm",
      property: "width",
      val: "3.0mm",
      order_id: 6,
      summary:"",
      // price:30000,
    },
    {
      id:28,
      step: 5,
      tab:3,
      stepJp:"リング幅",
      name: "3.2mm",
      property: "width",
      val: "3.2mm",
      order_id: 7,
      summary: "",
      // price:30000,
    },
    {
      id:29,
      step: 5,
      tab:3,
      stepJp:"リング幅",
      name: "3.4mm",
      property: "width",
      val: "3.4mm",
      order_id: 8,
      summary:"",
      // price:40000,
    },
    {
      id:30,
      step: 5,
      tab:3,
      stepJp:"リング幅",
      name: "3.6mm",
      property: "width",
      val: "3.6mm",
      order_id: 9,
      summary: "",
      // price:40000,
    },
    {
      id:31,
      step: 5,
      tab:3,
      stepJp:"リング幅",
      name: "3.8mm",
      property: "width",
      val: "3.8mm",
      order_id: 10,
      summary:"",
      // price:50000,
    },
  ]
}
